import React from 'react';
import {PropTypes} from 'prop-types';
import './CardWidget.scss';
import hrbLogo from '../../resources/images/hrb-logo.svg';
import CardWidgetSubmitButton from "./CardWidgetSubmitButton";
import CardWidgetAltButton from "./CardWidgetAltButton";

const CardWidgetInactivity = (props) => (
    <div>
      <div className="hrb-card-widget-container hrb-card-widget-container-no-top-margin">
        <div className="hrb-card-widget-logo">
          <img src={hrbLogo} alt="hrb-header-logo"/>
        </div>        
        <div className="hrb-card-widget-content-activity">
          {props.getCardSubtitle()}
        </div>
        <div className="hrb-card-widget-content-activity">
          {props.getCardContent()}
        </div>
        <div className="hrb-card-widget-button-container">
          {props.submitButtonAction &&
          <div className="hrb-card-widget-submit-button">
            <CardWidgetSubmitButton text={props.submitButtonText} onClick={props.submitButtonAction}
                params={props.submitButtonParams}
            />
          </div>
          }
          {props.cancelButtonAction &&
          <div className="hrb-card-widget-alt-button">
            <CardWidgetAltButton text={props.cancelButtonText} onClick={props.cancelButtonAction}
                params={props.cancelButtonParams}
            />
          </div>
          }
        </div>
      </div>
    </div>
);

CardWidgetInactivity.propTypes = {
  getCardContent: PropTypes.func.isRequired,
  getCardSubtitle: PropTypes.func.isRequired,
  submitButtonText: PropTypes.string,
  submitButtonAction: PropTypes.func,
  submitButtonParams: PropTypes.object,
  cancelButtonText: PropTypes.string,
  cancelButtonAction: PropTypes.func,
  cancelButtonParams: PropTypes.object
};

export default CardWidgetInactivity